// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__OAedd","emails":"CreateEditClinics_emails__sQER5","emailTagLabel":"CreateEditClinics_emailTagLabel__2AWdi"};